import { render, staticRenderFns } from "./upi-accounts.vue?vue&type=template&id=2f0df082&"
import script from "./upi-accounts.vue?vue&type=script&lang=js&"
export * from "./upi-accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports